import React from 'react'
import { FaCheck, FaCrown } from 'react-icons/fa'

const Pricing = () => {
  const plans = [
    {
      name: 'Free',
      price: '$0',
      period: 'forever',
      features: [
        '10 measurements per month',
        'Basic fish identification',
        'Local storage only',
        'Standard export'
      ],
      notIncluded: [
        'Cloud storage',
        'Advanced species database',
        'Priority support',
        'Ad-free experience'
      ],
      cta: 'Get Started',
      popular: false
    },
    {
      name: 'Pro Monthly',
      price: '$9.99',
      period: 'per month',
      features: [
        'Unlimited measurements',
        'AI species identification',
        'Cloud storage & sync',
        'Export without watermark',
        'Advanced species database',
        'Priority support',
        'Ad-free experience',
        'Fishing regulations info'
      ],
      notIncluded: [],
      cta: 'Start Free Trial',
      popular: true
    },
    {
      name: 'Pro Yearly',
      price: '$49.99',
      period: 'per year',
      savings: 'Save 58%',
      features: [
        'Everything in Pro Monthly',
        'Offline mode',
        'Early access to new features',
        'Exclusive fishing tips',
        'Weather integration',
        'Tide charts',
        'Moon phase tracking',
        'Premium support'
      ],
      notIncluded: [],
      cta: 'Best Value',
      popular: false
    }
  ]

  return (
    <section id="pricing" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Choose Your Plan
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Start free and upgrade when you need more features. Cancel anytime.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300 ${
                plan.popular ? 'ring-2 ring-primary-600' : ''
              }`}
            >
              {plan.popular && (
                <div className="absolute top-0 right-0 bg-primary-600 text-white px-4 py-1 text-sm font-semibold rounded-bl-lg">
                  Most Popular
                </div>
              )}
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {plan.name}
                </h3>
                <div className="mb-6">
                  <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                  <span className="text-gray-600 ml-2">{plan.period}</span>
                  {plan.savings && (
                    <span className="block text-green-600 font-semibold mt-1">
                      {plan.savings}
                    </span>
                  )}
                </div>
                
                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <FaCheck className="text-green-500 mt-1 mr-3 flex-shrink-0" />
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                  {plan.notIncluded.map((feature, idx) => (
                    <li key={idx} className="flex items-start opacity-50">
                      <span className="text-gray-400 mt-1 mr-3">✕</span>
                      <span className="text-gray-500 line-through">{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <button
                  className={`w-full py-3 px-6 rounded-lg font-semibold transition-colors ${
                    plan.popular
                      ? 'bg-primary-600 text-white hover:bg-primary-700'
                      : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                  }`}
                >
                  {plan.cta}
                </button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-gray-600">
            All plans include a 7-day free trial. No credit card required.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Pricing